import { useSearchParams, useNavigate } from "react-router-dom";
import Header from "../shared/Header";
import { useEffect } from "react";
import Footer from "../shared/Footer";
import { decryptConfig } from "../utils/decrypt";

export default function PaymentStatus() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const encrypted = searchParams.get("data");
  const decryptedRaw = decryptConfig(encrypted);
  const decrypted =
    typeof decryptedRaw === "string"
      ? JSON.parse(decryptedRaw)
      : decryptedRaw;
  console.log("Decrypted Payment Data:", decrypted);

  if (!decrypted) {
    return <div>Invalid payment response</div>;
  }
  const getStatusStyles = (status) => {
    switch (status) {
      case "S":
         return {
          backgroundColor: "#28a745",
          icon: "fa-check",
          label: "Payment Successful",
          buttonClass: "btn-success",
        };
        
      case "P":
        return {
          backgroundColor: "#ffc107",
          icon: "fa-clock-o",
          label: "Payment Pending",
          buttonClass: "btn-warning",
        };
      default:
       return {
          backgroundColor: "#dc3545",
          icon: "fa-times",
          label: "Payment Failed",
          buttonClass: "btn-danger",
        };
    }
  };

  const { backgroundColor, icon, label, buttonClass } = getStatusStyles(
    decrypted.status);
  return (
    <>
      <div className="container-scroller">
        <Header />

        <div className="container-fluid page-body-wrapper">
          <div className="main-panel">
            <div className="content-wrapper payment-page">
              <section className="content-header mb-5" />

              <div
                className="card text-center mb-8"
                style={{
                  padding: "40px",
                  borderRadius: "12px",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                  borderBottom: `5px solid ${backgroundColor}`,
                  width: "490px",
                  margin: "0 auto",
                }}
              >
                <div
                  style={{
                    backgroundColor,
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    margin: "0 auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <i
                    className={`fa ${icon}`}
                    style={{ color: "white", fontSize: "32px" }}
                    aria-hidden="true"
                  ></i>
                </div>

                <h3 style={{ marginTop: "20px", marginBottom: "30px" }}>
                  {label}
                </h3>

                <div className="text-left" style={{ marginTop: "20px" }}>
                  <div className="d-flex justify-content-between mb-2">
                    <strong>Order ID</strong>
                    <span>{decrypted.orderId}</span>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <strong>Transaction ID</strong>
                    <span>{decrypted.t_id}</span>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <strong>Transaction Amount</strong>
                    <span>{decrypted.amount}/-</span>
                  </div>

                  <div className="d-flex justify-content-between">
                    <strong>Transaction Date & Time</strong>
                    <span>{decrypted.t_date}</span>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <button
                      className={`btn ${buttonClass}`}
                      style={{ marginTop: "50px" }}
                      onClick={() => {
                        if (decrypted.status === "S") { navigate("/appointment-status") }
                        else { navigate("/appointment-status") }
                      }
                      }>
                      Back to Dashboard{" "}
                      <i className="fa fa-arrow-right ml-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
